import React from 'react';

import type {StepViewFieldProps} from '../commonprops';

export const StepViewTextareaField = ({field}: StepViewFieldProps) => (
  <div className="form-group row mb-0">
    {field.label !== '' ? (
      <label
        htmlFor={`step-field-${field.id}`}
        className="col-12 col-form-label pt-0"
      >
        {field.label}
      </label>
    ) : null}
    <div className="col-12">
      <textarea
        id={`step-field-${field.id}`}
        disabled
        className="form-control"
      ></textarea>
    </div>
  </div>
);
